<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'Zones',
  };
</script>

<style scoped>

</style>
